import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, BehaviorSubject} from 'rxjs';
import {AppConfig} from '../../app.config';
@Injectable()
export class FrontUserService  {
  static InjectorInstance: HttpClient;
  static Config: AppConfig;

  users: any[];
  onUsersChanged: BehaviorSubject<any> = new BehaviorSubject({});
  countryId = '';
  citiesId = [];
  organizationonsId = [];
  rolesId = [];
  addSuccess = false;
  targetGroups = [];
  tags = [];
  parishOrganizations = [];
  activities = [];
  activated: any = '';
  noActivated: any = '';
  cityIds: BehaviorSubject<any> = new BehaviorSubject([]);
  static checkEmail (email) {
    return FrontUserService.InjectorInstance.get(FrontUserService.Config.baseUrl + '/user/checkEmail?email=' + email ,
      FrontUserService.Config.jsonTokenHeaders);
  }


  constructor (private http: HttpClient , private api: AppConfig) {
    FrontUserService.InjectorInstance = this.http;
    FrontUserService.Config = this.api;
  }


  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve (route: ActivatedRouteSnapshot , state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return new Promise<void>((resolve , reject) => {

      Promise.all([
        this.countryId = '' ,
        this.citiesId = [] ,
        this.rolesId = [] ,
        this.organizationonsId = [] ,
        this.targetGroups = []
      ]).then(
        () => {
          resolve();
        } ,
        reject
      );
    });
  }

  getUsersCount () {
      this.http.get(this.api.baseUrl + '/frontUser/frontUsers?countryId=' + this.countryId + '&citiesId=' +
        this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() + '&organizationsId=' + this.organizationonsId.toString() +
        '&targetGroupsId=' + this.targetGroups.toString() + '&tags=' + this.tags.toString() + '&verify=1&active=' + this.activated
        + '&noActive=' + this.noActivated,
        this.api.jsonTokenHeaders);
  }

  getUsersNew (page = 1, perPage = 50, sort = 'name', direction = 'ASC', search = '',
               deleteRequest = false, platformId = '') {
    return this.http.get(this.api.baseUrl + '/frontUser/frontUsersNew?countryId=' + this.countryId +
      '&citiesId=' + this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() +
      '&organizationsId=' + this.organizationonsId.toString() + '&targetGroupsId=' + this.targetGroups.toString()
      + '&tags=' + this.tags.toString() + '&verify=1&active=' + this.activated + '&noActive=' + this.noActivated +
      '&page=' + page + '&perPage=' + perPage + '&sort=' + sort + '&direction=' + direction + '&search=' + search +
      '&deleteRequest=' + deleteRequest + '&platformId=' + platformId + '&parishOrganizations=' +
      this.parishOrganizations.toString() + '&activities=' + this.activities.toString(),
      this.api.jsonTokenHeaders);
  }


  getUserById (id) {
    return this.http.get(this.api.baseUrl + '/frontUser/frontUser?id=' + id , this.api.jsonTokenHeaders);
  }

  getLevelStatus () {
    return this.http.get(this.api.baseUrl + '/eventLevel/eventLevels' , this.api.jsonTokenHeaders);
  }

  getTargetGroup (withSettings = true) {
    return this.http.get(this.api.baseUrl + '/targetGroup/targetGroups?withSettings=' + withSettings , this.api.jsonTokenHeaders);
  }

  getConfession () {
    return this.http.get(this.api.baseUrl + '/confession/confessions' , this.api.jsonTokenHeaders);
  }


  getRoles () {
    return this.http.get(this.api.baseUrl + '/frontRole/frontRoles' , this.api.jsonTokenHeaders);
  }

  getDocuments (id) {
    return this.http.get(this.api.baseUrl + '/document/documents?type=frontUser&id=' + id , this.api.jsonTokenHeaders);
  }

  addUser (data) {
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[ key ]) {
        formData.append(key , data[ key ]);
      }

      if (data.hasOwnProperty(key) && !data[ key ] ) {
        formData.append(key , '');
      }
    }

    return this.http.post(this.api.baseUrl + '/frontUser/addFrontUser' , formData , this.api.formDataHeaders);
  }

  deleteUser (id) {
    return this.http.get(this.api.baseUrl + '/frontUser/deleteUser?id=' + id , this.api.jsonTokenHeaders);
  }

  checkEmailValid (email, mainEmail?) {
    return this.http.get(this.api.baseUrl + '/frontUser/checkEmail?email=' + email + '&mainEmail=' + mainEmail , this.api.jsonTokenHeaders);
  }

  setCountryId (id) {
    this.countryId = id;
    this.citiesId = [];
    this.organizationonsId = [];
    this.tags = [];
    this.parishOrganizations = [];
    this.activities = [];
  }

  setCities (city) {
    if (city.selected) {
      if (this.citiesId.indexOf(city.canton) === -1) {
        this.citiesId.push(city.canton);
      }
    } else {
      const index = this.citiesId.indexOf(city.canton);
      if (index !== -1) {
        this.citiesId.splice(index , 1);
      }
    }
    this.setCityIds(this.citiesId);
  }

  setCityIds(ids) {
    this.cityIds.next(ids);
  }

  getCities() {
    return this.citiesId;
  }

  getOrganizations() {
    return this.organizationonsId;
  }

  getTags() {
    return this.tags;
  }

  getParishOrganizations() {
    return this.parishOrganizations;
  }

  getActivities() {
    return this.activities;
  }

  getTargetGroups() {
    return this.targetGroups;
  }

  getRolesIds(){
    return this.rolesId;
  }

  setOrganizations (organization) {
    if (organization === 'clear') {
      this.organizationonsId = [];
    } else {
      if (organization.selected) {
        if (this.organizationonsId.indexOf(organization.organization) === -1) {
          this.organizationonsId.push(organization.organization);
        }
      } else {
        const index = this.organizationonsId.indexOf(organization.organization);
        if (index !== -1) {
          this.organizationonsId.splice(index , 1);
        }
      }
    }
  }
  setTags (tag) {
    if (tag.selected) {
      if (this.tags.indexOf(tag.tag) === -1) {
        this.tags.push(tag.tag);
      }
    } else {
      const index = this.tags.indexOf(tag.tag);
      if (index !== -1) {
        this.tags.splice(index , 1);
      }
    }
  }

  setParishOrganizations(parishOrganization) {
    if (parishOrganization.selected) {
      if (this.parishOrganizations.indexOf(parishOrganization.parishOrganization) === -1) {
        this.parishOrganizations.push(parishOrganization.parishOrganization);
      }
    } else {
      const index =  this.parishOrganizations.indexOf(parishOrganization.parishOrganization);
      if (index !== -1) {
        this.parishOrganizations.splice(index, 1);
      }
    }
  }
  setActivities(activity) {
    if (activity.selected) {
      if (this.activities.indexOf(activity.activity) === -1) {
        this.activities.push(activity.activity);
      }
    } else {
      const index =  this.activities.indexOf(activity.activity);
      if (index !== -1) {
        this.activities.splice(index, 1);
      }
    }
  }
  setTargetGroups(targetGroup) {
    if (targetGroup.selected) {
      if (this.targetGroups.indexOf(targetGroup.targetGroups) === -1) {
        this.targetGroups.push(targetGroup.targetGroups);
      }
    } else {
      const index =  this.targetGroups.indexOf(targetGroup.targetGroups);
      if (index !== -1) {
        this.targetGroups.splice(index, 1);
      }
    }
  }
  setRoles (roles) {
    if (roles.selected) {
      if (this.rolesId.indexOf(roles.role) === -1) {
        this.rolesId.push(roles.role);
      }
    } else {
      const index = this.rolesId.indexOf(roles.role);
      if (index !== -1) {
        this.rolesId.splice(index , 1);
      }
    }
  }
  setActivated (activated) {
    if (activated) {
      this.activated = 1;
    } else {
      this.activated = '';
    }
  }

  setNoActivated (noActivated) {
    if (noActivated) {
      this.noActivated = 1;
    } else {
      this.noActivated = '';
    }
  }

  setToAll () {
    this.countryId = '';
    this.citiesId = [];
    this.rolesId = [];
    this.organizationonsId = [];
    this.tags = [];
    this.parishOrganizations = [];
    this.activities = [];
    this.targetGroups = [];
    this.setCityIds([]);
  }

  getOrganizationByCantons () {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCantons?cantons=' + this.citiesId.toString() , this.api.jsonTokenHeaders);
  }

  getTagByOrganization() {
    return this.http.get(this.api.baseUrl + '/tag/tagsByOrganizations?organizations=' + this.organizationonsId  , this.api.jsonTokenHeaders);
  }

  getOrganizationByCantonId (id) {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCantons?cantons=' + id.toString() , this.api.jsonTokenHeaders);
  }

  getUserTG (id, tg) {
    return this.http.get(this.api.baseUrl + '/frontUser/userCreditTarget?id=' + id + '&tg=' + tg , this.api.jsonTokenHeaders);
  }
  getAllUserTG (id, allTgIds) {
    return this.http.get(this.api.baseUrl + '/frontUser/userCreditTargetAll?id=' + id + '&tg=' + allTgIds, this.api.jsonTokenHeaders);
  }
  getUsersByIds (ids) {
    return this.http.get(this.api.baseUrl + '/frontUser/userByIds?ids=' + ids , this.api.jsonTokenHeaders);
  }
  guestUserByIds (ids) {
    return this.http.get(this.api.baseUrl + '/guestUsers/guestUserByIds?ids=' + ids , this.api.jsonTokenHeaders);
  }
  getAdminByIds (ids) {
    return this.http.get(this.api.baseUrl + '/user/userByIds?ids=' + ids , this.api.jsonTokenHeaders);
  }

  getClan (id) {
    return this.http.get(this.api.baseUrl + '/frontUser/clan?token=' + id + '&type=backend' , this.api.jsonTokenHeaders);
  }
  getAllTG (id) {
    return this.http.get(this.api.baseUrl + '/participant/targetGroups?type=backEnd&token=' + id , this.api.jsonTokenHeaders);
  }

  sendEmailPass (id) {
    return this.http.get(this.api.baseUrl + '/frontUser/sendPassEmail?id=' + id , this.api.jsonTokenHeaders);
  }

  getRewards(id, tg) {
    return this.http.get(this.api.baseUrl + '/reward/getCredits?token=' + id + '&type=backEnd&tg=' + tg , this.api.jsonTokenHeaders);
  }

  getAllRewards(id, tgs) {
    return this.http.get(this.api.baseUrl + '/reward/getAllCredits?token=' + id + '&type=backEnd&tg=' + tgs , this.api.jsonTokenHeaders);
  }

  getEvents(id, tg) {
    return this.http.get(this.api.baseUrl + '/participant/findByUser?token=' + id + '&type=backEnd&tg=' + tg , this.api.jsonTokenHeaders);
  }

  getAllEvents(id) {
    return this.http.get(this.api.baseUrl + '/participant/findByUserAllEvents?token=' + id + '&type=backEnd', this.api.jsonTokenHeaders);
  }

  getListOfRewards(id, tg) {
    return this.http.get(this.api.baseUrl + '/reward/getRewards?id=' + id + '&type=backEnd&tg=' + tg , this.api.jsonTokenHeaders);
  }

  deleteReward(id) {
    return this.http.get(this.api.baseUrl + '/reward/deleteRewards?id=' + id  , this.api.jsonTokenHeaders);
  }

  deleteEventReward(eventId, userId) {
    return this.http.get(this.api.baseUrl + '/reward/deleteEventReward?eventId=' + eventId + '&userId=' + userId, this.api.jsonTokenHeaders);
  }

  addRewards(data) {
    return this.http.post(this.api.baseUrl + '/reward/addManualRewards', data, this.api.jsonTokenHeaders);
  }

  addRewardsToAll(data) {
    return this.http.post(this.api.baseUrl + '/reward/addManualRewardsToAll', data, this.api.jsonTokenHeaders);
  }


  updateAllYearsRewards (userId = '', orgId = '') {
    return this.http.get(this.api.baseUrl + '/frontUser/calculateUserCredits?ids=' + userId + '&orgId=' + orgId, this.api.jsonTokenHeaders);
  }

  migrateUser(data) {
    return this.http.post(this.api.baseUrl + '/frontUser/migrateUser', data, this.api.jsonTokenHeaders);
  }

  bookEvent(data) {
    return this.http.post(this.api.baseUrl + '/participant/bookEventManual', data, this.api.jsonTokenHeaders);
  }

  addCommunicationMail(data) {
    return this.http.post(this.api.baseUrl + '/communication/addCommunicationMail', data, this.api.jsonTokenHeaders);
  }
  addCommunicationSMS(data) {
    return this.http.post(this.api.baseUrl + '/communication/addCommunicationSMS', data, this.api.jsonTokenHeaders);
  }
  addCommunicationWhatsApp(data) {
    return this.http.post(this.api.baseUrl + '/communication/addCommunicationWhatsApp', data, this.api.jsonTokenHeaders);
  }
  addCommunicationSerial(data) {
    return this.http.post(this.api.baseUrl + '/communication/addCommunicationSerial', data, this.api.jsonTokenHeaders);
  }

  saveTeplate(data) {
    return this.http.post(this.api.baseUrl + '/communicationData/addTemplate', data, this.api.jsonTokenHeaders);
  }


  validationUser(data) {
    return this.http.post(this.api.baseUrl + '/frontUser/validationUser', data, this.api.jsonTokenHeaders);
  }

  listTags() {
    return this.http.get(this.api.baseUrl + '/tag/listTags', this.api.jsonTokenHeaders);
  }


  getTemplates(type) {
    return this.http.get(this.api.baseUrl + '/communicationData/templates?type=' + type, this.api.jsonTokenHeaders);
  }

  getNumberOfNew() {
    return this.http.get(this.api.baseUrl + '/frontUser/numberOfNew', this.api.jsonTokenHeaders);
  }

  deleteTeplate(id) {
    return this.http.get(this.api.baseUrl + '/communicationData/deleteTeplate?id=' + id, this.api.jsonTokenHeaders);
  }
  getTimeLine(id) {
    return this.http.get(this.api.baseUrl + '/timeLog/timeLogs?id=' + id + '&type=backend'  );
  }

  activeTimeLog(id) {
    return this.http.get(this.api.baseUrl + '/timeLog/active?id=' + id  );
  }
  disactiveTimeLog(id) {
    return this.http.get(this.api.baseUrl + '/timeLog/disactive?id=' + id  );
  }
  exportUser(platformId) {
    return this.api.baseUrl + '/frontUser/downloadFilev2?countryId=' + this.countryId + '&citiesId=' +
      this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() + '&organizationsId=' +
      this.organizationonsId.toString() + '&targetGroupsId=' + this.targetGroups.toString() + '&tags=' +
      this.tags.toString() + '&parishOrganizations=' + this.parishOrganizations.toString() + '&activities=' + this.activities.toString() +
      '&verify=1&active=' + this.activated + '&noActive=' + this.noActivated + '&token=' + this.api.token + '&platformId=' + platformId;

  }

  exportUserXLSX(platformId) {
    return this.api.baseUrl + '/frontUser/downloadXLSXv2?countryId=' + this.countryId + '&citiesId=' +
      this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() + '&organizationsId=' +
      this.organizationonsId.toString() + '&targetGroupsId=' + this.targetGroups.toString() + '&tags=' +
      this.tags.toString() + '&parishOrganizations=' + this.parishOrganizations.toString() + '&activities=' + this.activities.toString() +
      '&verify=1&active=' + this.activated + '&noActive=' + this.noActivated + '&token=' + this.api.token + '&platformId=' + platformId;
  }

  refreshCredits(orgId) {
    return this.http.get(this.api.baseUrl + '/frontUser/calculateUserCredits?orgId=' + orgId );
  }

  editTG(data) {
    return this.http.post(this.api.baseUrl + '/frontUser/editTG', data, this.api.jsonTokenHeaders);
  }

  editParticipantTG(data) {
    return this.http.post(this.api.baseUrl + '/participant/editTG', data, this.api.jsonTokenHeaders);
  }

  editRewards(data) {
    return this.http.post(this.api.baseUrl + '/reward/editRewardsTG', data, this.api.jsonTokenHeaders);
  }

  deleteUserConnections(id, type) {
    return this.http.get(this.api.baseUrl + '/frontUser/deleteUserConnections?id=' + id + '&type=' + type , this.api.jsonTokenHeaders);
  }


  checkParentConnection(userId, connectedUserId) {
    return this.http.get(this.api.baseUrl + '/frontUser/checkParentConnection?id=' + connectedUserId + '&userId=' + userId, this.api.jsonTokenHeaders);
  }

  removeDeleteRequest(userId) {
    return this.http.get(this.api.baseUrl + '/frontUser/removeDeleteRequest?userId=' + userId, this.api.jsonTokenHeaders);
  }

  deleteUserProfile(userId) {
    return this.http.get(this.api.baseUrl + '/frontUser/deleteUserProfile?userId=' + userId, this.api.jsonTokenHeaders);
  }

  getUserCompetencies(userId) {
    return this.http.get(this.api.baseUrl + '/frontUser/skills?id=' + userId, this.api.jsonTokenHeaders);
  }
}
